import { StatsActions } from './constants'
import qs from 'qs'
import { getEnv } from 'aria-viewer/utils/environment'

const isStatsEnabled = isEnabled => state => {
    const searchQuery = qs.parse(state.get('routing').location.search, { ignoreQueryPrefix: true })
    const debugMode = searchQuery.debug

    return getEnv('NODE_ENV') === 'production' ? isEnabled && debugMode == 3 : isEnabled
}

export const toggleStats = _ => (dispatch, getState) => {
    const state = getState()
    const enableStats = isStatsEnabled(!state.getIn(['stats', 'enableStats']))(state)

    dispatch(setStatsEnabled(enableStats))
}

export const setStatsEnabled = enabled => ({
    type: StatsActions.SET_STATS_ENABLED,
    enabled,
})

export const setMeanFPS = (meanFPS, interval) => ({
    type: StatsActions.SET_MEAN_FPS,
    meanFPS,
    interval,
})

export const setFPSMeterEnabled = enabled => ({
    type: StatsActions.SET_FPS_METER_ENABLED,
    enabled,
})
